# ------------------------------------*|
#     #Editor Layout -> Tutorials
# ------------------------------------*|

moduleTutorials = angular.module "services.tutorials", []

moduleTutorials.factory 'Tutorials',  ["$timeout", "ns", "$injector", "$rootScope", "$cookies", ($timeout, ns, $injector, $rootScope, $cookies) ->

  tutorials =
    _sectionDropTutorial: ->
      $timeout.cancel(@sectionDestroyTimeOut) if @sectionDestroyTimeOut
      $rootScope.sectionDropTutorial = true
      $rootScope.$apply()
      @sectionDestroyTimeOut = $timeout ->
        $rootScope.sectionDropTutorial = false
      , 8000
  tutorials
]



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/tutorials.coffee